import React from "react";
import {
    Row, Col, Card, CardHeader,
    CardBody, CardFooter,
    FormGroup, Label
} from "reactstrap";
import Select from 'react-select';
import randomColor from "randomcolor";
import Chart from 'chart.js';
import { GetSalePersonList } from "../../api/SalePersonApi";
import { colors } from "react-select/lib/theme";

class SalePerson extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dateValue: "day",
            data: [],
            startDate: this.props.DataFromDashboard.selectedStartDate,
            endDate: this.props.DataFromDashboard.selectedEndDate,
            operator: this.props.DataFromDashboard.paramOperator,
            productType: this.props.DataFromDashboard.paramType,
            companyId: this.props.DataFromDashboard.companyId,
            userId: this.props.DataFromDashboard.userId,
            roleId: this.props.DataFromDashboard.roleId,
        }

        this.canvasRef = React.createRef();
    }

    bindData(){    
        const {data} = this.state;
        let displayNameArr = [];
        let sellPriceArr = [];
        const colors = randomColor({count : 200});
        
        data.forEach((item) => {
            displayNameArr.push(item.displayName);
            sellPriceArr.push(item.sellPrice);
        });

        const labels = displayNameArr.map((name, index) => `${name} - ${sellPriceArr[index].toLocaleString('en')}`);
        this.setState({chartData: {...this.state.chartData, labels}});

        let DataSetAry = [];
        let defaultColor = [];
        for (let j = 0; j < displayNameArr.length; j++) {
            defaultColor[j] = colors[j];
        }

        for (let i = 0; i < displayNameArr.length; i++) {
            DataSetAry[0] = {
                backgroundColor: defaultColor,
                borderColor: "rgba(0,123,255,1)",
                pointBackgroundColor: "#ffffff",
                pointHoverBackgroundColor: "rgb(0,123,255)",
                borderWidth: 1.5,
                pointRadius: 0,
                pointHoverRadius: 5,

                data: sellPriceArr,
            };
        }

        this.setState({chartData: {...this.state.chartData, datasets: DataSetAry}});
    }

   async componentDidMount() {
        const resdata = await GetSalePersonList(this.state);
        this.setState({data: resdata});
        this.bindData();

        if(this.state.data.length !== 0){
        const  chartOptions = {
            ...{
                legend: {
                    position: "left",
                    labels: {
                      padding: 20,
                      boxWidth: 20,
                    }
                  },
                  cutoutPercentage: 0,
                  tooltips: {
                    custom: false,
                    mode: "index",
                    position: "nearest",
                    callbacks: {
                        label: function (tooltipItem, data) {
                            const label = data.labels[tooltipItem.index];
                            return label;
                          }
                    }
                  },
                  
                  
            },
        }
        const BlogUsersOverview = new Chart(this.canvasRef.current, {
            type: 'pie',
            data: this.state.chartData,
            options: chartOptions
        });
        BlogUsersOverview.render();
    }

        
    }

    updateState(prop, value) {
        this.setState({ [prop]: value });
    }

    render() {
            return (
                <Card small className="h-100">
                    <CardHeader className="border-bottom">
                        <h6 className="m-0">Sale Person</h6>
                    </CardHeader>
                    <CardBody className="d-flex py-0">
                    {this.state.data.length === 0 ? 
                (
                    <div className="m-auto text-muted" style={{ fontSize: '1.2rem' , height: '200px', padding: '20px', margin: '10px',
                    display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        No Data
                    </div>
                ) : (
                    <canvas
                        height="100"
                        ref={this.canvasRef}
                        className="blog-users-by-device m-auto"
                    />
                )
            }
                    </CardBody>
                    <CardFooter className="border-top">
                    </CardFooter>
                </Card>
            );
        }
        
    // }
}


export default SalePerson;
